import { NonRentableSpaceClass } from '../../../models/space/non-rentable-space.class';
import { isNotNullOrEmptyString } from '../../../shared/utils/functions';

export interface NonRentableData {
  item: NonRentableSpaceClass;
  floorNo: string;
  totalNumberOfFloors: number;
  suiteNumber?: string;
  spaceSize?: number;
  spaceSizeUOM?: string;
  isReplacingTenant?: boolean;
  isUnaccounted?: boolean;
}

export interface ReqNonRentableData {
  floorId: number;
  floorNumber: string;
  suiteNo: string;
  spaceName: string;
  spaceSize: string;
  spaceSizeUOM: string;
  notes: string;
  suiteId: number;
}

export class ReqUpdateNonRentableSpace {
  'request.source_id': number;

  private static AttributesMap = {
    floorId: 'property_space.floor_id',
    floorNumber: 'property_space.floor_number',
    suiteNo: 'property_space.suite_number',
    suiteId: 'property_space.suite_id',
    spaceName: 'property_space.non_rentable_space.space_classification_type_desc',
    spaceSize: 'property_space.non_rentable_space.non_rentable_size',
    spaceSizeUOM: 'property_space.non_rentable_space.non_rentable_size_uom_desc',
    notes: 'property_space.non_rentable_space.notes',
  };

  constructor(
    // tslint:disable-next-line:variable-name
    public property_id: number,
    nonRentableData: ReqNonRentableData
  ) {
    this['request.source_id'] = property_id;
    this.transformToRealRequestObj(nonRentableData, ReqUpdateNonRentableSpace.AttributesMap);
  }

  protected transformToRealRequestObj(
    nonRentableData: Partial<ReqNonRentableData>,
    attributesMap: { [key: string]: string }
  ) {
    Object.entries(nonRentableData)
      .filter(([, val]) => isNotNullOrEmptyString(val))
      .forEach(([key, value]) => {
        const attribute = attributesMap[key];
        if (attribute != null) {
          this[attribute] = value;
        }
      });
  }

  get suiteId() {
    return this['property_space.suite_id'];
  }

  deleteSuiteId() {
    delete this['property_space.suite_id'];
  }
}

export interface ReqDeleteNonRentableSpace {
  property_id: number;
  'request.source_id': number;
  floor_id: number;
  suite_id: number;
}
